module.exports = __webpack_public_path__ + "static/media/lock.4ac84c52.svg";